import * as React from "react"
import { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import classNames from "classnames"

const samplePageLinks = [
  { text: "Home", url: "/" },
  { text: "Search", url: "/search" },
  { text: "New", url: "/new-dresses" },
  { text: "Prom", url: "https://www.shopformaldress.com/search" },
  { text: "Midi", url: "/midi-dresses" },
  { text: "Maxi", url: "/maxi-dresses" },
  { text: "Mini", url: "/mini-dresses" },
  { text: "Party", url: "/party-dresses" },
  { text: "Bridesmaid Dresses", url: "/bridesmaid-dresses" },
  { text: "Activewear", url: "https://www.coactivewear.com/search" },
  { text: "Tops", url: "https://www.collectivetops.com/search" },
  { text: "Swims", url: "https://www.collectiveswimwear.com/search" },  
  { text: "Blog", url: "/blog" },
  { text: "About", url: "/about" },
]

const SUBNAV = [
  { text: "Search", url: "/search" },
  { text: "Midi", url: "/midi-dresses" },
  { text: "Maxi", url: "/maxi-dresses" },
  { text: "Mini", url: "/mini-dresses" },
  { text: "Bridesmaid", url: "/bridesmaid-dresses" },
  { text: "Party", url: "/party-dresses" },
  { text: "Prom", url: "https://www.shopformaldress.com/search" },
  { text: "Swims", url: "https://www.collectiveswimwear.com/search" },
  { text: "Activewear", url: "https://www.coactivewear.com/search" },
  { text: "About", url: "/about" },
]

const Header = ({ siteTitle }) => {
  // Sticky Menu Area
  useEffect(() => {
    window.addEventListener("scroll", isSticky)
    return () => {
      window.removeEventListener("scroll", isSticky)
    }
  })

  const [navbar, setNavbar] = useState(false)

  /* Method that will fix header after a specific scrollable */
  const isSticky = e => {
    const header = document.querySelector(".header-container")
    const scrollTop = window.scrollY
    scrollTop >= 550
      ? header.classList.add("is-sticky")
      : header.classList.remove("is-sticky")
  }

  return (
    <header className="header-container flex flex-col items-center pb-0">
      <div className="logo-desktop">
        <Link to="/">
        <StaticImage
          src="../images/logo-crop.png"
          loading="eager"
          fetchpirority="high"
          width={350}
          quality={95}
          formats={["auto", "webp", "avif"]}
          alt="Collective Dress Logo"
          style={{ marginBottom: `var(--space-3)` }}
          className="hidden md:block"
        />
        </Link>
      </div>

      <div className="hidden md:block">
        <ul className="flex my-0">
          {samplePageLinks.map((link, i) => (
            <React.Fragment key={link.url}>
              <li className="mr-6">
                <Link
                  className={classNames(
                    "nav-link",
                    "text-l",
                    "text-black",
                    "no-underline",
                    "hover:text-opacity-60",
                    { "nav-sales": link.text == "Prom" },
                    { "nav-special": link.text == "Tops" },
                    { "nav-special": link.text == "Search" }
                  )}
                  to={link.url}
                  activeClassName="link-active"
                >
                  {link.text}
                </Link>
              </li>
            </React.Fragment>
          ))}
        </ul>
      </div>
      <nav className="w-full bg-white md:hidden">
        <div className="justify-between mx-auto lg:max-w-7xl md:items-center md:flex md:px-8">
          <div>
            <div className="flex items-center justify-between md:py-5 md:block px-4 py-2">
              <a href="/">
                <StaticImage
                  src="../images/logo-mobile.jpg"
                  loading="eager"
                  fetchpirority="high"
                  width={250}
                  quality={95}
                  formats={["auto", "webp", "avif"]}
                  alt="Collective Dress Logo"
                />
              </a>
              <div className="md:hidden">
                <button
                  className="p-2 text-gray-700 rounded-md outline-none focus:border-gray-400 focus:border"
                  onClick={() => setNavbar(!navbar)}
                >
                  {navbar ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-6 h-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4 6h16M4 12h16M4 18h16"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>
            <div className="flex flex-row items-center justify-between flex-nowrap gap-3 border border-solid overflow-auto px-4 py-1">
              {SUBNAV.map((item, index) => (
                <Link
                  key={index}
                  className={classNames(
                    "text-l",
                    "text-black",
                    "no-underline",
                    "whitespace-nowrap",
                    { "nav-sales": item.text == "Sales" },
                    { "nav-special": item.text == "Search" },
                    { "nav-special": item.text == "New" }
                  )}
                  to={item.url}
                >
                  {item.text}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <div
              className={`flex-1 justify-self-center pb-3 mt-8 md:block md:pb-0 md:mt-0 ${
                navbar ? "block" : "hidden"
              }`}
            >
              <ul className="menu-mobile-list-container items-center justify-center space-y-8 md:flex md:space-x-6 md:space-y-0">
                {samplePageLinks.map((link, i) => (
                  <React.Fragment key={link.url}>
                    <li className="text-gray-600 hover:text-blue-600">
                      <Link
                        className={classNames(
                          "nav-link",
                          "text-l",
                          "text-black",
                          "no-underline",
                          "hover:text-opacity-60",
                          { "nav-sales": link.text == "Formal" },
                          { "nav-special": link.text == "Tops" },
                          { "nav-special": link.text == "Search" }
                        )}
                        to={link.url}
                        activeClassName="link-active"
                      >
                        {link.text}
                      </Link>
                    </li>
                  </React.Fragment>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
